import React from 'react';
import RadioList from './RadioList';
import { FieldValues, Path } from 'react-hook-form';
import { translate } from '../../services/translate';

function CameraTypeList<
    TFieldValues extends FieldValues,
    TName extends Path<TFieldValues>,
>({ name }: { name: TName; }) {
    return <RadioList items={['ptz', 'lpr', 'pinned', 'panoramic'].map(type => ({
        label: translate(type),
        value: type,
    }))} name={name} clearValue={null} />;
}

CameraTypeList.getCount = RadioList.getCount;

export default CameraTypeList;
